import React from 'react';
import QueueAnim from 'rc-queue-anim';
import TweenOne from 'rc-tween-one';
import { Row, Col, Image } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';
import title_rare from "./img/SVG/title_art_utility.svg";
import Citation from "./Citation.jsx";
import decor1 from "./img/decor_3.jpg";

class Content3 extends React.PureComponent {
  getDelay = (e, b) => (e % b) * 100 + Math.floor(e / b) * 100 + b * 100;

  render() {
    const { ...props } = this.props;
    const { dataSource, isMobile } = props;
    delete props.dataSource;
    delete props.isMobile;
    let clearFloatNum = 0;
    const children = dataSource.block.children.map((item, i) => {
      const childObj = item.children;
      const delay = isMobile ? i * 50 : this.getDelay(i, 24 / item.md);
      const liAnim = {
        opacity: 0,
        type: 'from',
        ease: 'easeOutQuad',
        delay,
      };
      const childrenAnim = { ...liAnim, x: '+=10', delay: delay + 100 };
      clearFloatNum += item.md;
      clearFloatNum = clearFloatNum > 24 ? 0 : clearFloatNum;
      return (
        <TweenOne
          component={Col}
          animation={liAnim}
          key={item.name}
          {...item}
          componentProps={{ md: item.md, xs: item.xs }}
          className={
            !clearFloatNum
              ? `${item.className || ''} clear-both`.trim()
              : item.className
          }
        >
          <TweenOne
            animation={{
              x: '-=10',
              opacity: 0,
              type: 'from',
              ease: 'easeOutQuad',
            }}
            key="img"
            {...childObj.icon}
          >
            <img src={childObj.icon.children} width="100%" alt="img" />
          </TweenOne>
          <div {...childObj.textWrapper}>
            <TweenOne
              key="h2"
              animation={childrenAnim}
              component="h2"
              {...childObj.title}
            >
              {childObj.title.children}
            </TweenOne>
            <TweenOne
              key="p"
              animation={{ ...childrenAnim, delay: delay + 200 }}
              component="div"
              {...childObj.content}
            >
              {childObj.content.children}
            </TweenOne>
          </div>
        </TweenOne>
      );
    });
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <Image src={title_rare} height={"170px"} preview={false}/>
          <Citation 
              citation="The goal of life is to make your heartbeat match the beat of the universe, to match your nature with Nature."
              author="Joseph Campbell"
          />
          <Image className="nature-decor-rarity" src={decor1} preview={false}/>

{/*           <div {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
          </div>
 */}          <OverPack {...dataSource.OverPack}>
            <QueueAnim key="u" type="bottom">
              <Row key="row" {...dataSource.block}>
                {children}
              </Row>
            </QueueAnim>
          </OverPack>
        </div>
        <Row>
          <Col span={24}>
{/*               <p className="timeline-text">
                  <span className="emphasis">Minting giveaways</span>
              </p>
              <p className="timeline-text">
                  We are planning super exciting giveaways during our mint from <b>November 30 9PM CST</b>:
              </p>
              <p className="timeline-text">
                  {"•	Airdrops of very special, personalized NFTs to lucky winners. This is not found anywhere else!\n \
                  •	Signed and printed art copies.\n \
                  •	Exclusive private card readings sessions with the creator of the cards.\n \
                  •	And much more!"}
              </p>
 */}              
              <p className="timeline-text">
                  Follow us on <a href="https://twitter.com/NatureOracle" target="_blank">Twitter</a> + <a href="https://medium.com/@NatureOracle" target="_blank">Medium</a> to be in the loop!
              </p>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Content3;
